// extracted by mini-css-extract-plugin
module.exports = {"message":"tdk4i","icon":"FS3GA","text":"f8XQM","message_inline":"fkbN+","icon_inline":"_0ALjB"};